<script>

  import TryButton from "$lib/TryButton.svelte"

</script>
<section class="relative overflow-hidden">
  <!-- Text Content -->
  <div class="relative z-10 text-center max-w-3xl mx-auto px-4 py-24">
    <h2 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
      <span class="text-am-black">One</span>
      <span class="text-am-blue">Link</span>.
      <span class="text-am-black">Zero</span>
      <span class="text-am-white-60">Noise</span>
    </h2>
    
    <p class="text-am-black-75 text-lg mb-12 max-w-2xl mx-auto">
      Share your AddMeetings link anywhere in emails, messages, or on LinkedIn and let it do the filtering for you. All meeting requests are automatically screened so only the most relevant ones reach you while the rest are filtered out, allowing you to have the right conversations.
    </p>
    
    <TryButton>It's Free - Try Now!</TryButton>
  </div>

  <!-- Video Section -->
  <div class="relative overflow-hidden aspect-video w-full max-h-[90vh]">
    <img
      src="/images/man-in-video-meeting.webp"
      alt="Man participating in video meeting on his laptop"
      class="w-full h-full object-cover"
    />
  </div>
</section>